"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Spinner_styled_1 = require("./Spinner.styled");
function Spinner(_a) {
    var _b = _a.delay, delay = _b === void 0 ? 0 : _b;
    var _c = react_1.default.useState(!delay), visible = _c[0], setVisible = _c[1];
    react_1.default.useEffect(function () {
        if (delay) {
            var tid_1 = setTimeout(function () { return setVisible(true); }, delay);
            return function () { return clearTimeout(tid_1); };
        }
    }, [delay]);
    return react_1.default.createElement(Spinner_styled_1.StyledSpinner, { className: "Spinner", visible: visible });
}
exports.Spinner = Spinner;
function LoadingOverlay(props) {
    return (react_1.default.createElement(Spinner_styled_1.StyledLoadingOverlay, { className: "LoadingOverlay" },
        react_1.default.createElement(Spinner, __assign({}, props))));
}
exports.LoadingOverlay = LoadingOverlay;
